// The Admin view: HR tools behind the same sign-in, reached from the header's Admin tab.
// Sections are sub-tabs; each has its own path so a link or reload lands on the same one.
// HR.Agent sees Requests only; HR.Admin sees everything. The API enforces the same split.

import { linkTo } from "../router.js";
import { AnalyticsPage } from "./AnalyticsPage.js";
import { DocumentsPage } from "./DocumentsPage.js";
import { RequestsPage } from "./RequestsPage.js";
import { SourcesPage } from "./SourcesPage.js";

export const ADMIN_SECTIONS = [
  ["requests", "Requests", "agent"],
  ["analytics", "Analytics", "agent"],
  ["documents", "Documents", "admin"],
  ["sources", "Sources", "admin"],
] as const;
export type AdminSection = (typeof ADMIN_SECTIONS)[number][0];

export function sectionsFor(isAdmin: boolean) {
  return ADMIN_SECTIONS.filter(([, , need]) => need === "agent" || isAdmin);
}

export function adminSection(path: string, isAdmin: boolean): AdminSection {
  const s = path.split("/")[2];
  const allowed = sectionsFor(isAdmin);
  return allowed.find(([id]) => id === s)?.[0] ?? allowed[0]?.[0] ?? "requests";
}

export function Admin({ path, isAdmin }: { path: string; isAdmin: boolean }) {
  const section = adminSection(path, isAdmin);
  const openId = section === "requests" ? (/^\/admin\/requests\/([0-9a-z]+)$/.exec(path)?.[1] ?? null) : null;
  return (
    <>
      <nav className="subtabs" aria-label="Admin sections">
        {sectionsFor(isAdmin).map(([id, label]) => (
          <a key={id} href={`/admin/${id}`} onClick={linkTo(`/admin/${id}`)} aria-current={section === id ? "page" : undefined}>
            {label}
          </a>
        ))}
      </nav>
      {section === "requests" ? <RequestsPage openId={openId} /> : null}
      {section === "analytics" ? <AnalyticsPage /> : null}
      {section === "documents" ? <DocumentsPage /> : null}
      {section === "sources" ? <SourcesPage /> : null}
    </>
  );
}
